import React from "react";
import parser from "mini-html-parser";
import { flatten } from "../../utils/lodash";

const findScripts = (node) => {
    if (node.nodeName && node.nodeName === "SCRIPT")
        return (node.childNodes || []).map((n) => n.nodeValue);
    return flatten((node.childNodes || []).map(findScripts));
};

interface Props {
    render?(html: string): JSX.Element;
    scriptKey: string;
    html: string;
}

export function ExecutableHtml(props: Props): JSX.Element {
    const { html, scriptKey, render } = props;

    React.useEffect(() => {
        const timeout = setTimeout(() => {
            const content = html;
            const scripts = findScripts(parser(content).parse());
            scripts.forEach((script) => {
                (window as any).eval(`${script}\n//# sourceURL=${scriptKey}.js`);
            });
        });
        return function cleanup() {
            clearTimeout(timeout);
        };
    }, [html, scriptKey]);

    if (render) return render(html);
    return <div dangerouslySetInnerHTML={{ __html: html }} />;
}
